export const fabrics = [
  {
    Предприятие:
      "ООО Угличский завод минеральной воды",
    title: "ООО Угличский завод минеральной воды",
    description:
      "Ярославнефтеоргсинтез («Славнефть-Ярославнефтеоргсинтез», «Славнефть-ЯНОС») — крупнейший нефтеперерабатывающий завод севера России. Расположен в Ярославле.",
    latitude: -3,
    longitude: -132,
    count: 6,
    inn: 5408010484,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 82,
  },
  {
    Предприятие: "Энергосберегающие Системы Отопления",
    title: "Энергосберегающие Системы Отопления",
    description:
      "Производственная компания «ЭСО» Энергосберегающие Системы Отопления — российский разработчик, поставщик и производитель гипсокартонных панелей отопления ТМ «REVOLTS». Компания более 10 лет функционирует на рынке теплового оборудования. Производство базируется в г. Ярославль. Компания выпускает иновационные, энергосберегающие гипсокартонные греющие панели для основного или дополнительного обогрева жилых и нежилых помещений (квартиры, частные дома, офисы). Обогреватели предназначены для установки на потолке, стенах.",
    latitude: 0,
    longitude: -131,
    count: 4,
    inn: 111111111112,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 68,
  },
  {
    Предприятие: "Консервный завод Поречский",
    title: "Консервный завод Поречский",
    description:
      "Агрохолдинг «Поречье» — многопрофильное предприятие, расположенное в экологически чистом районе Ярославской области, которое производит выпуск широкого ассортимента качественных и натуральных продуктов питания",
    latitude: 1,
    longitude: -132,
    count: 1,
    inn: 111111111113,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 45,
  },
  {
    Предприятие: "Станки трейд",
    title: "Станки трейд",
    description:
      "МЫ ПРОИЗВОДИМ:- фрезерное оборудование с ЧПУ для фрезеровки и обработки дерева, камня и мягких металлов;- гидроабразивные станки с ЧПУ, для резки любого материала на земле;- плазменные станки с ЧПУ для раскроя листового металла;- ТВЧ установки для закалки и нагрева металла",
    latitude: -1,
    longitude: -133,
    count: 3,
    inn: 111111111114,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 78,
  },

  {
    Предприятие: "Даниловский завод деревообрабатывающих станков (ДЗДС)",
    title: "Даниловский завод деревообрабатывающих станков (ДЗДС)",
    description:
      "Осенью 1941 года в Данилов был эвакуирован из калининской области Торжокский мотороремонтный завод, который стал именоваться Даниловский мотороремонтный завод.",
    latitude: -2,
    longitude: -145,
    count: 7,
    inn: 111111111115,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 69,
  },
  {
    Предприятие: "Завод минеральной воды",
    title: "Завод минеральной воды",
    description: "Завод минеральной воды",
    latitude: -2,
    longitude: -149,
    count: 6,
    inn: 111111111116,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 40,
  },
  {
    Предприятие: 'ИП Иванов А.С, ООО "Закупка России"',
    title: 'ИП Иванов А.С, ООО "Закупка России"',
    description: 'ИП Иванов А.С, ООО "Закупка России"',
    latitude: -2,
    longitude: -149,
    count: 6,
    inn: 111111111116,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 40,
  },
  {
    Предприятие: 'ИП Петров А.С, ООО "Покупки в России"',
    title: 'ИП Петров А.С, ООО "Покупки в России"',
    description: 'ИП Петров А.С, ООО "Покупки в России"',
    latitude: -2,
    longitude: -149,
    count: 6,
    inn: 111111111116,
    kpp: 540801001,
    ogrn: 1165476121612,
    okved: "11.07. Производство безалкогольных напитков; производство упакованных питьевых вод, включая минеральные воды",
    trusted: 40,
  },
];
